export default (weight) => {
  return weight.toLocaleString("pt-br", { minimumFractionDigits: 2 });
};
